export * from '../ui/step'

export enum StepState {
  CURRENT = 'current',
  DONE = 'done',
  TODO = 'todo',
}
